import { useState, useMemo, useEffect } from "react";
import { authService } from "../dependencyInjection";
import { unsubscribe } from "../../../../utils";
import { RequestStatus } from "..";

export type UsePasswordAdd = (userId: number, code: string, newPassword: string) => Promise<void>;

export function usePasswordAdd(): [RequestStatus, UsePasswordAdd] {
  const [status, setStatus] = useState(RequestStatus.None);
  const passwordAdd: UsePasswordAdd = useMemo(
    () => async (userId, code, newPassword) => {
      setStatus(RequestStatus.Pending);
      try {
        await authService.passwordAdd(userId, code, newPassword);
        localStorage.removeItem("isPasswordExpired")
      } catch (err) {}
    },
    [],
  );

  useEffect(() => {
    const sub = authService.status$.subscribe((code) => {
      setStatus(code);
    });
    return unsubscribe(sub);
  }, []);

  return [status, passwordAdd];
}
